import { Api } from 'api';
import { all, put, select, call, takeEvery } from 'redux-saga/effects';
import * as appActions from 'root/appActions';
import * as Sentry from '@sentry/react';
import * as companyActions from "../features/company/companyActions";
import { Company, SagaGenerator, Token, User } from 'types';
import { getCompanyDetails, getCompanyFeaturePermissions } from '../features/company/companySaga';
import { authSlice } from 'features/auth/authSlice';
import { userSlice } from 'features/user/userSlice';
import { getCompany } from 'features/company/companyDetails';
import { setSentryScope } from 'sentryTools';


export function* appSaga(): SagaGenerator {
    return yield all([
        takeEvery(appActions.INITIALISE_MY_PARKD, initialiseMyParkd),
    ]);
}

export function* initialiseMyParkd() {
    yield provideSentryWithScope();
    const token: Token = yield select(authSlice.selectors.getLocalToken);
    if (token) {
        yield getCompanyDetails(); // required to get 'onboardedOn' status
        yield put(companyActions.getTelematicAccountTypes());
        yield getCompanyFeaturePermissions();
    }
}

export function* provideSentryWithScope() {
    Sentry.addBreadcrumb({ category: 'appSaga', message: 'provideSentryWithScope' });
    const token: Token = yield select(authSlice.selectors.getLocalToken);
    const user: User = yield select(userSlice.selectors.getUser);
    const company: Company = yield select(getCompany);

    setSentryScope(token, user, company);
}


export function* callApi(method: any, ...params: any) {
    const state = yield select();
    return yield callApiWithToken(method, state.auth?.token, ...params);
}

export function* callApiWithToken(method: any, token: string, ...params: any) {
    const state = yield select();
    if (state.auth.token) {
        return yield call([Api, method], state.auth.token, ...params);
    } else {
        return yield call([Api, method], null, ...params);
    }
}

export function* callApiWithoutToken(method: any, ...params: any) {
    return yield call([Api, method], ...params);
}
